const listeners = [];

let idCounter = 0;

function emit(payload) {
  const item = { ...payload, id: ++idCounter };
  listeners.forEach((fn) => fn(item));
}

export const toast = {
  success: (msg, duration = 3000) => emit({ type: 'success', msg, duration }),
  error:   (msg, duration = 4000) => emit({ type: 'error',   msg, duration }),
  info:    (msg, duration = 3000) => emit({ type: 'info',    msg, duration }),
};

export function subscribeToast(fn) {
  listeners.push(fn);
  return () => {
    const i = listeners.indexOf(fn);
    if (i > -1) listeners.splice(i, 1);
  };
}
